// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { categoryInformationStyles } from "@guestsupply/App/Widgets/CategoryInformation/CategoryInformation";
import { xScreen } from "@guestsupply/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

categoryInformationStyles.container = {
    css: css`
        display: flex;
        width: 100%;
        align-items: flex-start;
        gap: 22px;
        margin-bottom: 36px;
        ${xScreen("lte", "md")} {
            gap: 20px;
        }
        ${xScreen("lte", "sm")} {
            flex-direction: column;
        }
    `,
};

categoryInformationStyles.titleDescriptionWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
        flex: 1 1 0%;
        /* Remove border bottom in category view. */
        .category-title-wrapper {
            border: none;
            padding-bottom: 0;
            ${xScreen("lte", "sm")} {
                &,
                ${TypographyStyle} {
                    margin-bottom: 0;
                }
            }
        }
    `,
};

categoryInformationStyles.imageWrapper = {
    css: css`
        width: 656px;
        height: 262px;
        text-align: right;
        img {
            border-radius: 4px;
        }
        ${xScreen("lte", "md")} {
            width: 358px;
            height: 144px;
        }
        ${xScreen("lte", "sm")} {
            width: 100%;
            height: 132px;
        }
    `,
};
